import { FunctionComponent } from 'react'
import styled from 'styled-components'

import { addCommas } from 'utils/stringFormatting'

import * as T from 'types'

const PriceBox = styled.div`
  flex-direction: column;
  background-color: ${props => props.theme.colors.purple};
  padding: 40px 33px;
  margin-bottom: 10px;
  @media (min-width: ${props => props.theme.metrics.phone}px) {
    width: 100%;
    border-radius: 4px;
  }
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    width: auto;
  }
`

const Price = styled.div`
  font-weight: 900;
  font-size: 32px;
  color: ${props => props.theme.colors.white};
`

const Address = styled.div`
  font-size: 18px;
  color: ${props => props.theme.colors.white};
`

const Br = styled.br`
  display: none;
  @media (max-width: ${props => props.theme.metrics.phone}px) {
    display: block;
  }
`

interface IProps {
  listing: T.IListing
}

const PreviewDetails: FunctionComponent<IProps> = ({ listing }) => (
  <PriceBox>
    {(listing.price || listing.price === 0) && <Price>{`$${addCommas(listing?.price)}`}</Price>}
    <Address>
      {`${listing.street}`}
      {listing.aptNum ? ` Unit ${listing.aptNum},` : ','} <Br />
      {`${listing.city}, ${listing.state}, ${listing.zip}`}
    </Address>
  </PriceBox>
)

export default PreviewDetails
